<template>
  <v-card flat class="pa-3 mt-2">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card-text class="d-flex">
        <v-row>
          <v-col lg="6" md="6" cols="12">
            <v-text-field :rules="reglas.ci" v-model="datos.ci" label="Ci" required outlined dense hide-details="auto"
              class="mb-6"></v-text-field>
            <v-text-field :rules="reglas.nombre" v-model="datos.nombre" label="Nombre" required outlined dense
              hide-details="auto" class="mb-6"></v-text-field>

            <v-text-field :rules="reglas.apellido" v-model="datos.apellido" label="Apellido" required outlined dense
              hide-details="auto" class="mb-6"></v-text-field>
            <v-textarea v-model="datos.direccion" label="Direccion" required outlined name="input-7-4"></v-textarea>
          </v-col>
          <v-col lg="6" md="6" cols="12">
            <div>
              <v-avatar rounded size="120" class="me-6">
                <v-img :src="urlImg"></v-img>
              </v-avatar>
              <v-btn x-small color="primary" class="me-3 mt-5" @click="$refs.refInputEl.click()">
                <v-icon class="d-sm-none">
                  {{ icons.mdiCloudUploadOutline }}
                </v-icon>
                <span class="d-none d-sm-block">Subir imagen</span>
              </v-btn>

              <input ref="refInputEl" @change="ChangeImg" type="file" accept=".jpeg,.png,.jpg,GIF" :hidden="true" />

              <v-btn x-small color="error" outlined class="mt-5" @click="resetImg()"> Reset </v-btn>
              <p class="text-sm mt-5">Permitido JPG, GIF or PNG. Tamaño maximo 800K</p>
            </div>
            <v-text-field v-model="datos.telefono" label="Telefono" required outlined dense hide-details="auto"
              class="mb-6"></v-text-field>
            <v-select v-model="datos.tipo_empleado" :items="empleadosTipo" item-text="descripcion" item-value="id"
              :rules="reglas.tipo_empleado" label="Tipo Empleado" required hide-details="auto" class="mb-6" outlined
              dense></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text>
        <v-btn color="primary" class="me-3  " @click="GuardarDatos()"> Siguiente </v-btn>
        <v-btn color="secondary" outlined @click="ResetFormulario()"> Cancelar </v-btn>

      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import { onBeforeMount, ref, watch } from '@vue/composition-api'
import { mdiAlertOutline, mdiCloudUploadOutline, mdiCamera } from '@mdi/js'
import SeguridadService from '@/api/servicios/SeguridadService'


export default {
  props: {
    EmpleadoData: Object,
  },
  components: {},
  setup(props, context) {
    const datos = ref({ ...props.EmpleadoData.empleado });
    watch(props, () => {
      console.log("cambio de props");
      datos.value = { ...props.EmpleadoData.empleado };
      urlImgSet()
    });
    const empleadosTipo = ref([]);

    onBeforeMount(() => {
      SeguridadService.obtenerEmpleadoTipos()
        .then(response => {
          console.log(response);
          if (response.data.mensaje == "BUSQUEDA_EXITOSA") {
            empleadosTipo.value = response.data.datos;
          }
        })
        .catch(error => {
          console.log(error);
        });
    });

    const urlImg = ref(require("@/assets/images/avatars/1.png"));

    const resetImg = () => {
      datos.value.imgInput = null;
      urlImgSet();
    };
    const ChangeImg = e => {
      datos.value.imgInput = e.target.files[0];
      console.log(URL.createObjectURL(datos.value.imgInput));
      urlImgSet();
    };
    const urlImgSet = () => {
      if (!datos.value.imgInput) {
        if (datos.value.img != '') {
          console.log(datos.value.img)
          console.log("imgane null");
          urlImg.value = `http://localhost:5001/empleado/img/${datos.value.img}`;
        } else {
          console.log("imgane null");
          urlImg.value = require("@/assets/images/avatars/1.png");
        }

      }
      else {
        const imgs = URL.createObjectURL(datos.value.imgInput);
        console.log("imgane");
        urlImg.value = imgs;
      }
    };
    const reglas = {
      apellido: [
        v => !!v || "Apellido es requerido",
        v => (v && v.length <= 20 && v.length >= 3) || "Apellido debe ser valido",
      ],
      ci: [
        v => !!v || "Cedula es requerido",
        v => (v && v.length >= 7 && v.length <= 8) || "Cedula Invalida",
        v => !Number.isInteger(v) || "Cedula Invalida",
      ],
      clave: "",
      clave2: "",
      direccion: "",
      id: -1,
      id_usuario: -1,
      img: "",
      modulo: "",
      nombre: [
        v => !!v || "Nombre es requerido",
        v => (v && v.length <= 20 && v.length >= 3) || "Nombre debe ser valido",
      ],
      telefono: "",
      tipo_empleado: [v => !!v || "Tipo empleado es requerido"],
      usuario: "",
    };

    const ResetFormulario = () => {
      context.emit("ResetFormulario");
    }

    const GuardarDatos = () => {
      if (validarForm()) {
        context.emit("CambiarTab", 1);
      } else {
        store.commit('setAlert', {
          message: 'Verifique que todos los datos estén completos',
          type: 'info',
        })

      }
    }
    const valid = ref(true);
    const name = ref("");
    const nameRules = [
      v => !!v || "Name is required",
      v => (v && v.length <= 10) || "Name must be less than 10 characters",
    ];
    const email = ref("");
    const emailRules = [v => !!v || "E-mail is required", v => /.+@.+..+/.test(v) || "E-mail must be valid"];
    const select = ref(null);
    const items = ["Item 1", "Item 2", "Item 3", "Item 4"];
    const checkbox = ref(false);
    const form = ref(null);

    const validarForm = () => {
      let val = form.value?.validate()

      return val
    }
    const validate = () => {
      form.value.validate();
      console.log(form.value.validate());
    };
    const reset = () => {
      form.value.reset();
    };
    const resetValidation = () => {
      form.value.resetValidation();
    };
    return {
      form,
      valid,
      name,
      nameRules,
      email,
      emailRules,
      select,
      items,
      checkbox,
      validate,
      reset,
      resetValidation,
      datos,
      icons: { mdiCloudUploadOutline, mdiAlertOutline, mdiCamera },
      reglas,
      empleadosTipo,
      urlImg,
      resetImg,
      ChangeImg,
      GuardarDatos,
      validarForm,
      ResetFormulario
    };
  }

}
</script>